import { Button, Card, Input, Message, Space, Upload, Table } from "@arco-design/web-react";
import { IconEdit, IconPlus } from "@arco-design/web-react/icon";
import OperationButton from "@/components/OperationButton";
import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ItemAPI } from "@/apis/material";
import { EnumLabel, EnumSelect } from "@/components/Enum";
import { StatusDef } from "@/enums/status";
import { ItemTypeDef } from "@/enums/material";
import ItemDocButton from "./item-doc";
import { baseUrl } from "@/utils/api";
import { ItemInfoLink } from "@/components/ItemInfoLink";
import { ItemAdd } from "./item-add";
import { ItemEdit } from "./item-edit";

export const Items = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [itemName, setItemName] = useState();
    const [status, setStatus] = useState(1);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState();

    const getItems = useCallback(async () => {
        const params = {
            page: page,
            name: itemName,
            status: status
        }
        const res = await ItemAPI.query(params);
        setData(res.records);
        setPagination((pagination) => ({
            ...pagination,
            current: page,
            total: res.total
        }));
    }, [itemName, status, page]);

    const onItemUpload = (fileList, file) => {
        if (file.status === "done") {
            Message.success("Upload Successfully");
            getItems();
        } else if (file.status === "error") {
            Message.error(`${file.response.message}`)
        }
    }

    useEffect(() => {
        getItems();
    }, [getItems]);

    return (
        <Card title={
            <Space>
                <Input allowClear placeholder="Item Name" onChange={(val) => {
                    setItemName(val);
                }} />
                <EnumSelect enumObj={StatusDef} value={status} style={{ width: 100 }} allowAll placeholder="Status" onChange={(val) => {
                    setStatus(val);
                }} />
            </Space>
        } extra={
            <Space >
                <Link to="/workspace/material/items/add">
                    <Button type="primary" icon={<IconPlus />}>Add New Item</Button>
                </Link>
                <Upload withCredentials
                    headers={{ 'bee-access-token': localStorage.getItem("login.token") }}
                    action={`${baseUrl}/item/import`}
                    onChange={onItemUpload}
                    showUploadList={false}>
                    <Button type="primary">Import Items</Button>
                </Upload>
                <Button type="primary" onClick={() => window.location = `${baseUrl}/ItemTemplate.xlsx`}>Download Template</Button>
            </Space>
        }>
            <Table columns={[
                { title: "Item Type", render: (col, record) => <EnumLabel enumObj={ItemTypeDef} value={record.itemType} /> },
                {
                    title: "Item Number",
                    render: (col, record) => <ItemInfoLink value={record.id}>{record.itemNo}</ItemInfoLink>
                },
                { title: "Item Name", dataIndex: "itemName" },
                {
                    title: "Status", dataIndex: "status",
                    render: (col, record) =>
                        <EnumLabel enumObj={StatusDef} value={record.status} />
                },
                { title: "Description", dataIndex: "description" },
                {
                    title: "Operations", dataIndex: "op",
                    width: 100,
                    render: (col, record) => <Space size="mini">
                        <ItemDocButton itemId={record.id} />
                        <OperationButton icon={<IconEdit />} label="Edit" onClick={() => {
                            navigate(`/workspace/material/items/${record.id}/edit`);
                        }} />
                    </Space>
                }
            ]} rowKey="id"
                data={data}
                pagination={pagination}
                onChange={(pagination) => setPage(pagination.current)}>
            </Table>
        </Card>
    );
}

Items.Add = ItemAdd;
Items.Edit = ItemEdit;
